import { GROUPS, PREFIX } from '@/service/apiConf';
import { get } from '@/service/request';

export const UrlMap = {
  list: (search) =>
    `${PREFIX.vapis(GROUPS.iam)}/yourselfworkspaces?sort=desc${search ? `&name=${search}` : ''}`,
};

export function getList(search, flag = false) {
  return get(`${UrlMap.list(search)}`, null, { flag });
}
